import { Tag } from '@bedrock/components'
import React from 'react';

const TravelTag = (props) => {
  const { value, style, detail, need_actual_execution, className} = props;
  
  if (detail?.depth !== 2 || 
    !detail?.$contentStructured  || 
    !need_actual_execution
  ) {
    return null;
  }
  
  if (value) {
    return (
      <Tag text='含差旅餐饮等实报实销' color='orange' size='xSmall' style={style} className={className} />
    )
  }

  // return <Tag text='不含差旅餐饮等实报实销' color='grey' size='xSmall' style={style} />
  return null;
}

export default TravelTag
